var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"tile":"","size":_vm.size}},[(_vm.iconPath !== '')?_c('v-img',{attrs:{"src":require(("" + _vm.iconPath))}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }